<script lang="ts" setup>
defineProps({
    isSolid: {
        type: Boolean,
        default: false
    }
})
</script>

<template>
    <svg
        v-if="isSolid"
        xmlns="http://www.w3.org/2000/svg"
        class="fill-current"
        viewBox="0 0 24 24"
    >
        <path
            fill-rule="evenodd"
            d="M15.2483 6.35159c.225.22503.3513.5302.3513.8484 0 .31819-.1263.62336-.3513.8484L11.2967 12l3.9516 3.9516c.2186.2263.3395.5294.3368.8441-.0027.3146-.1289.6156-.3514.8381-.2225.2225-.5235.3487-.8381.3514-.3147.0027-.6178-.1182-.8441-.3368l-4.80001-4.8c-.22496-.225-.35134-.5302-.35134-.8484 0-.3182.12638-.6234.35134-.8484l4.80001-4.80001c.225-.22497.5302-.35135.8484-.35135.3182 0 .6234.12638.8484.35135Z"
            clip-rule="evenodd"
        />
    </svg>

    <svg
        v-else
        xmlns="http://www.w3.org/2000/svg"
        class="fill-current"
        viewBox="0 0 24 24"
    >
        <path
            fill-rule="evenodd"
            d="M15.7071 4.29289c.3905.39053.3905 1.02369 0 1.41422L9.41421 12l6.29289 6.2929c.3905.3905.3905 1.0237 0 1.4142-.3905.3905-1.0237.3905-1.4142 0l-7.00001-7c-.39052-.3905-.39052-1.0237 0-1.4142l7.00001-7.00001c.3905-.39052 1.0237-.39052 1.4142 0Z"
            clip-rule="evenodd"
        />
    </svg>
</template>
